module.exports = __webpack_public_path__ + "img/img_logo.8a70edee.svg";